<div [ngClass]="navigationSharedData?.prevStep === 0 ? 'enabled' : 'disabled'">
  <app-edit-site
    *ngIf="navigationSharedData?.step === 1"
    [selectedSite]="sharedData?.selectedSite"
    [navigateToAddBuilding]="navigateToAddBuilding"
    [selectedBuilding]="sharedData?.selectedBuilding"
    [navigateConfirmDialog]="navigateConfirmDialog"
    [closeConfirmDialog]="closeConfirmDialog"
    [noErrorToasterShow]="noErrorToasterShow"
  >
  </app-edit-site>

  <app-add-building-details
    *ngIf="navigationSharedData?.step === 2"
    [selectedSite]="sharedData?.selectedSite"
    [resetNavigation]="resetNavigation"
    [navigateToEditSite]="navigateToEditSite"
    [navigateToAddBuilding]="navigateToAddBuilding"
    [navigateToAddFloor]="navigateToAddFloor"
    [enableBackOperation]="enableBackOperation"
    [selectedBuilding]="sharedData?.selectedBuilding"
    [navigateConfirmDialog]="navigateConfirmDialog"
    [closeConfirmDialog]="closeConfirmDialog"
    [result]="result"
  >
  </app-add-building-details>

  <app-add-floor-details
    *ngIf="navigationSharedData?.step === 3"
    [selectedSite]="sharedData?.selectedSite"
    [selectedBuilding]="sharedData?.selectedBuilding"
    [resetNavigation]="resetNavigation"
    [navigateToAddBuilding]="navigateToAddBuilding"
    [enableBackOperation]="true"
    [navigateConfirmDialog]="navigateConfirmDialog"
    [closeConfirmDialog]="closeConfirmDialog"
  ></app-add-floor-details>

  <app-remove-floor-unit
    *ngIf="navigationSharedData?.step === 5"
    [selectedSite]="sharedData?.selectedSite"
    [selectedBuilding]="sharedData?.selectedBuilding"
    [selectedFloor]="sharedData?.selectedFloor"
    [selectedUnit]="sharedData?.selectedUnit"
    [removeAP]="removeAP"
  ></app-remove-floor-unit>

  <app-edit-floor-unit
    *ngIf="navigationSharedData?.step === 6"
    [selectedSite]="sharedData?.selectedSite"
    [selectedBuilding]="sharedData?.selectedBuilding"
    [selectedFloor]="sharedData?.selectedFloor"
    [selectedUnit]="sharedData?.selectedUnit"
    [enableBackOperation]="enableBackOperation"
    [navigateConfirmDialog]="navigateConfirmDialog"
    [closeConfirmDialog]="closeConfirmDialog"
    [resetNavigation]="resetNavigation"
  >
  </app-edit-floor-unit>
  <app-filter-unit
    *ngIf="navigationSharedData?.step === 7"
    [selectedSite]="sharedData?.selectedSite"
    [selectedBuilding]="sharedData?.selectedBuilding"
    [selectedFloor]="sharedData?.selectedFloor"
    [selectedUnit]="sharedData?.selectedUnit"
    [enableBackOperation]="enableBackOperation"
    [filter]="sharedData?.filter"
  >
  </app-filter-unit>

  <app-master-credential *ngIf="navigationSharedData?.step === 8">
  </app-master-credential>

  <app-master-credential-detail
    *ngIf="navigationSharedData?.step === 9"
    [selectedSite]="sharedData?.selectedSite"
    [selectedMasterCredential]="sharedData?.selectedMasterCredential"
  >
  </app-master-credential-detail>

  <app-edit-master-credential-description
    *ngIf="navigationSharedData?.step === 10"
    [selectedSite]="sharedData?.selectedSite"
    [enableBackOperation]="enableBackOperation"
    [credential]="sharedData?.selectedMasterCredential"
    [navigateToEditSite]="navigateToEditSite"
  >
  </app-edit-master-credential-description>

  <app-activity
    *ngIf="navigationSharedData?.step === 11"
    [selectedSite]="sharedData?.selectedSite"
    [masterCredential]="sharedData?.selectedMasterCredential"
    [resetNavigation]="resetNavigation"
  >
  </app-activity>
</div>
